import React from 'react';
import { Card, CardBody, Typography } from "@material-tailwind/react";

/**
 * TypeSummaryTable - Displays summary of transactions grouped by type
 * @param {Object} props
 * @param {Object} props.typeSummaries - Object with type names as keys and {debit, credit, net, type, sub_type} as values
 * @param {Object} props.summary - Overall summary with totalDebit, totalCredit, balance
 */
const TypeSummaryTable = ({ typeSummaries, summary }) => {
    if (!typeSummaries || Object.keys(typeSummaries).length === 0) {
        return null;
    }

    return (
        <Card className="bg-white rounded-2xl shadow-xl p-6">
            <CardBody>
                <Typography variant="h5" color="blue-gray" className="mb-4">
                    Totals by Type
                </Typography>
                <div className="overflow-x-auto">
                    <table className="w-full min-w-max table-auto text-left border-collapse">
                        <thead>
                            <tr className="border-b-2 border-blue-gray-200">
                                <th className="p-3 bg-blue-gray-50 font-bold text-sm">Type</th>
                                <th className="p-3 bg-blue-gray-50 font-bold text-sm">Sub Type</th>
                                <th className="p-3 bg-blue-gray-50 font-bold text-sm">Description</th>
                                <th className="p-3 bg-blue-gray-50 font-bold text-sm text-right">Debit</th>
                                <th className="p-3 bg-blue-gray-50 font-bold text-sm text-right">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(typeSummaries).sort().map(([type, data]) => (
                                <tr key={type} className="border-b border-blue-gray-100 hover:bg-blue-gray-50 transition-colors">
                                    <td className="p-3 text-sm">
                                        <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-bold">
                                            {data.type || type}
                                        </span>
                                    </td>
                                    <td className="p-3 text-sm">
                                        <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium">
                                            {data.sub_type || '-'}
                                        </span>
                                    </td>
                                    <td className="p-3 text-sm font-medium text-blue-gray-700">{type}</td>
                                    <td className="p-3 text-sm text-right font-semibold text-red-600">
                                        {data.debit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                    <td className="p-3 text-sm text-right font-semibold text-green-600">
                                        {data.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </td>
                                </tr>
                            ))}
                            <tr className="bg-blue-gray-50 font-bold border-t-2 border-blue-gray-300">
                                <td colSpan="3" className="p-3 text-right text-sm">TOTALS:</td>
                                <td className="p-3 text-sm text-right text-red-700">
                                    {summary.totalDebit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                                <td className="p-3 text-sm text-right text-green-700">
                                    {summary.totalCredit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CardBody>
        </Card>
    );
};

export default TypeSummaryTable;
